import { render } from "./InviteContract.vue?vue&type=template&id=8db0b2ae&scoped=true"
import script from "./InviteContract.vue?vue&type=script&lang=js"
export * from "./InviteContract.vue?vue&type=script&lang=js"

import "./custom-invite-contract.scss?vue&type=style&index=0&id=8db0b2ae&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db0b2ae"]])

export default __exports__